import { Link } from 'react-router-dom';
import { Star, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

export const TrainerCard = ({ trainer, className = '' }) => {
  return (
    <div
      className={`relative overflow-hidden rounded-2xl bg-[#141414] border border-white/5 group hover:border-primary/50 transition-all duration-500 ${className}`}
      data-testid={`trainer-card-${trainer.id}`}
    >
      {/* Image Container */}
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={trainer.photo_url}
          alt={trainer.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
        
        {/* Rating Badge */}
        <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-full bg-black/60 backdrop-blur-sm">
          <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" />
          <span className="text-sm font-semibold text-white">{trainer.rating.toFixed(1)}</span>
        </div>
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="font-heading text-xl font-bold text-white uppercase tracking-tight mb-1">
          {trainer.name}
        </h3>
        
        <div className="flex items-center gap-1 text-gray-400 text-sm mb-3">
          <MapPin className="w-3.5 h-3.5" />
          <span>{trainer.location}</span>
        </div>

        {/* Specialties */}
        <div className="flex flex-wrap gap-2 mb-4">
          {trainer.specialties.slice(0, 2).map((specialty, index) => (
            <Badge
              key={index}
              variant="secondary"
              className="bg-white/5 text-gray-300 text-xs border-0"
            >
              {specialty}
            </Badge>
          ))}
          {trainer.specialties.length > 2 && (
            <Badge
              variant="secondary"
              className="bg-white/5 text-gray-400 text-xs border-0"
            >
              +{trainer.specialties.length - 2}
            </Badge>
          )}
        </div>

        {/* Action Button */}
        <Link to={`/trainer/${trainer.id}`}>
          <Button
            className="w-full bg-primary/10 text-primary hover:bg-primary hover:text-white border border-primary/30 hover:border-primary transition-all duration-300"
            data-testid={`view-profile-${trainer.id}`}
          >
            View Profile
          </Button>
        </Link>
      </div>
    </div>
  );
};
